import React from 'react';
import { 
  Keyboard
} from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const shortcuts = [
  { keys: ['Double Click'], action: 'Edit text directly on canvas' },
  { keys: ['Escape'], action: 'Cancel text editing' },
  { keys: ['Ctrl', 'Enter'], action: 'Save text and exit editing' },
  { keys: ['Delete'], action: 'Delete selected element' },
  { keys: ['Ctrl', 'Z'], action: 'Undo' },
  { keys: ['Ctrl', 'Y'], action: 'Redo' },
  { keys: ['Ctrl', 'S'], action: 'Save template' },
  { keys: ['Ctrl', '+'], action: 'Zoom in' },
  { keys: ['Ctrl', '-'], action: 'Zoom out' },
  { keys: ['Ctrl', '0'], action: 'Reset zoom to 100%' },
  { keys: ['Hold Shift'], action: 'Maintain aspect ratio while resizing' },
  { keys: ['Arrow Keys'], action: 'Fine-tune element position' },
  { keys: ['Ctrl', 'Shift', ']'], action: 'Bring element to front' },
  { keys: ['Ctrl', ']'], action: 'Bring element forward one layer' },
  { keys: ['Ctrl', '['], action: 'Send element backward one layer' },
  { keys: ['Ctrl', 'Shift', '['], action: 'Send element to back' },
  { keys: ['Right Click'], action: 'Open layer context menu' }
];

export const KeyboardShortcuts: React.FC = () => {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const cmdKey = isMac ? '⌘' : 'Ctrl';

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" title="Keyboard Shortcuts">
          <Keyboard className="w-4 h-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
          <DialogDescription>
            Quick actions to speed up your template design
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-4">
          {shortcuts.map((shortcut, index) => (
            <div key={index} className="flex items-center justify-between py-2 border-b last:border-0">
              <span className="text-sm text-gray-600">{shortcut.action}</span>
              <div className="flex items-center gap-1">
                {shortcut.keys.map((key, keyIndex) => (
                  <React.Fragment key={keyIndex}>
                    {keyIndex > 0 && <span className="text-gray-400 mx-1">+</span>}
                    <kbd className="px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-md">
                      {key.replace('Ctrl', cmdKey)}
                    </kbd>
                  </React.Fragment>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};